import React, { useMemo } from 'react'
import FaqAccordion from './FaqAccordion'

const FaqContainer = ({ description }) => {
  const accordionData = useMemo(() => {
    try {
      const inputArray = description.split(/\n\n/)
      return inputArray.map((item) => {
        const parts = item.split('\n')
        const title = parts[0].replace('###', '').trim()
        const content = parts.slice(1).join('\n').trim()
        return {
          title,
          content,
        }
      })
    } catch (error) {
      console.error('Error processing FAQ data', error)
      return null
    }
  }, [description])

  const data = accordionData

  return (
    <>
      {data && (
        <div>
          <hr />
          <h3 className='text-primary'>FAQ</h3>
          {data.map((item, index) => (
            <FaqAccordion key={index} title={item.title} content={item.content} />
          ))}
        </div>
      )}
    </>
  )
}

export default FaqContainer
